export const ReportTypes = ['INSIGHTS_REPORT'];

export const PageType = [
  {
    name: 'ALL_PAGES',
    value: 'allPages',
  },
];

export const ExportType = [
  {
    name: 'XLSX',
    value: 'xlsx',
  },
];

export enum ReportStatus {
  PENDING = 0,
  DONE = 1,
  FAILED = 2,
}
